import { SystemStyleObject } from '@chakra-ui/react';
import { ChainType } from '@cyberkongz/config-blockchain';
import { useChainEnhanced } from '@cyberkongz/ui-blockchain';
import { PropsWithChildren, useMemo } from 'react';

import { pxToRem } from '../../theme';
import { AppLinkWithArrow } from '../AppLink';

export function getTxPath(txHash?: string) {
  return `/tx/${txHash}`;
}

export function getAddressPath(address: string) {
  return `/address/${address}`;
}

type BlockExplorerLinkProps = PropsWithChildren & {
  path: string;
  chainType?: ChainType;
  styles?: {
    link?: SystemStyleObject;
    container?: SystemStyleObject;
  };
};

export function useChainUrl(chainType?: ChainType) {
  const { mainnetChain, polygonChain, roninChain } = useChainEnhanced();
  const url = useMemo(() => {
    const selectedChain =
      chainType === 'polygon' ? polygonChain : chainType === 'ronin' ? roninChain : mainnetChain;

    return selectedChain?.blockExplorers?.default.url;
  }, [chainType]);

  return { url };
}

export function ViewInBlockExplorerLink({
  children,
  path,
  chainType,
  styles,
}: BlockExplorerLinkProps) {
  const { url } = useChainUrl(chainType);

  return (
    <AppLinkWithArrow
      css={{ color: 'primary', ...styles?.link }}
      stylesContainer={{
        fontSize: 'xs',
        justifyContent: 'center',
        textTransform: 'uppercase',
        fontWeight: 'medium',
        ...styles?.container,
      }}
      sxIcon={{ width: pxToRem(14), height: 'auto' }}
      href={`${url}${path}`}
    >
      {children || 'View in block explorer'}
    </AppLinkWithArrow>
  );
}

export function BlockExplorerLink({ children, path, chainType }: BlockExplorerLinkProps) {
  const { url } = useChainUrl(chainType);

  return (
    <AppLinkWithArrow href={`${url}${path}`} sxIcon={{ w: 4 }}>
      {children}
    </AppLinkWithArrow>
  );
}
